import { Box, Button, Stack, Typography } from "@mui/material";
import { PaginationDetails } from "../interface/api_request";

const btnSty = {
  padding: "8px",
  borderRadius: "4px",
  fontFamily: "DM Sans",
  fontWeight: 700,
  fontSize: "12px",
  height: 35,
  color: "#9199A8",
  background: "#FAFBFD",
};
const mainBtn = {
  padding: "4px",
  minWidth: 35,
  height: 35,
  background: "#284CB1",
  color: "#FFFFFF",
  "&:hover": {
    background: "#284CB1",
  },
};

interface PaginationProps {
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}
export const Pagination = ({
  paginationState,
  setPaginationState,
}: PaginationProps) => {
  const { page, pages, hasNextPage, hasPrevPage } =
  paginationState;

  const handlePageChange = (newPage: number) => {
    // Update the pagination state and trigger refetch (if needed)
    setPaginationState((prevState) => ({
      ...prevState,
      page: newPage,
    }));
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Stack
        direction="row"
        spacing={2}
        justifyContent={"space-between"}
        sx={{ px: 3 }}
      >
        <Typography color={"neutral"} variant="body2">
          Showing {page} of {pages} entries
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            sx={{ ...btnSty }}
            disabled={!hasPrevPage}
            onClick={() => handlePageChange(page - 1)}
          >
            Previous
          </Button>
          <Button sx={{ ...mainBtn }}>{page}</Button>
          <Button
            sx={{ ...btnSty }}
            disabled={!hasNextPage}
            onClick={() => handlePageChange(page + 1)}
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};
